import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import DeleteExternalJobBoardForm from './DeleteExternalJobBoardForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const DeleteExternalJobBoardModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeDeleteExternalJobBoardModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.deleteExternalJobBoardModalIsOpen}
      contentLabel={'Delete External Job Board'}
      onRequestClose={() => {
        closeDeleteExternalJobBoardModal();
      }}
    >
      <PageTitle text={'Delete External Job Board'} />
      <DeleteExternalJobBoardForm />
    </StandardModal>
  );
};

export default DeleteExternalJobBoardModal;